import { Article } from '@/modules/shop/models/article';

function slotArticles(articles: Article[]): Article[] {
  // Separate articles with slots and without slots
  const articlesWithSlots = articles.filter(
    (article) => article.attributes.slot !== null
  );
  const articlesWithoutSlots = articles.filter(
    (article) => article.attributes.slot === null
  );

  // Sort articles with slots based on slot (ascending)
  const sortedArticlesWithSlots = articlesWithSlots
    .slice()
    .sort((a, b) => (a.attributes.slot ?? 0) - (b.attributes.slot ?? 0));

  // Adjust the positions of articles with slots in the array
  sortedArticlesWithSlots.forEach((article) => {
    const slot = article.attributes.slot ?? 0;
    articlesWithoutSlots.splice(slot - 1, 0, article);
  });

  return articlesWithoutSlots;
}

export default slotArticles;
